
<template>
    <div class="xiang-gong">
        <div class="xiang-gong-top">
            <!-- 背景图 -->
            <div class="bid-inner">
                <div class="bid-title">
                    全过程工程项目管理信息化解决方案
                </div>
                <div class="bid-bg"></div>
            </div>
        </div>

        <div class="qi-cont">
            <div class="qi-cont-top">
                <div class="inner">
                    <p class="title">{{bidText.title}}</p>
                    <p>{{bidText.p1}}</p>
                </div>

            </div>

            <div class="qi-cont-bot">
                <div class="inner">
                    <img src="/images/products/xiang-gong/qgc-1.png" alt="">
                    <img src="/images/products/xiang-gong/qgc-2.png" alt="">
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import CONFIG_PROJECT from '@config/project';

export default {
    head: {
        title: `产品和服务·${CONFIG_PROJECT.title}`,
    },
    name: '',
    components: {},
    data() {
        return {
            bidText: {
                title: '全过程工程项目管理信息化解决方案',
                p1: '按照国家顶层制度设计，河北省电子招标投标体系由电子交易平台、公共服务平台和行政监督平台三大部分组成。其中，公共服务平台是整个体系的中心枢纽，行政监督平台是支撑各级行政监管部门履行监管职责的在线系统工具，交易平台则市场主体完成全部招标投标活动的载体。从属性上来说，公共服务平台和行政监督平台属于政务服务属性，电子交易平台则属于电子商务属性。因此，前者由政府部门建设，后者则以市场化方式提供。',
            },
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.xiang-gong {
    background-color: #fff;
    width: 100%;
    min-height: 1000px;
    position: relative;
    .xiang-gong-top {
        z-index: 0;
        width: 100%;
        height: 360px;
        background: url('/products/erji-bg.png') no-repeat;
        background-size: 100% 100%;
        background-size: cover;

        .bid-inner {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            position: relative;
            .bid-title {
                width: 630px;
                color: #fff;
                font-weight: bold;
                font-size: 38px;
                position: absolute;
                top: 85px;
                left: 0;
            }
            .bid-bg {
                z-index: 10;
                position: absolute;
                top: 30px;
                right: 60px;
                width: 245px;
                height: 300px;
                background: url('/products/xiang-gong/bg.png') no-repeat;
                background-size: 100% 100%;
                background-size: cover;
            }
        }
    }

    .qi-cont {
        // width: 1200px;
        // margin: 70px auto 0;
        background-color: #f6fbfe;

        .qi-cont-top {
            padding: 30px 0;
            width: 100%;
            p {
                // font-weight: bold;
                font-size: 15px;
                color: #131415;
                margin: 30px 0;
                text-align: center;
            }
            .title {
                font-size: 24px;
                font-weight: bold;
                color: #131415;
            }
        }

        .qi-cont-bot {
            display: flex;
            justify-content: space-between;
            // margin-top: 40px;
            // padding-bottom: 40px;

            .inner{
                text-align: center;
                img{
                    margin-bottom: 60px;
                }
            }
            
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
